export default __webpack_public_path__ + "static/media/grid_pdf.8b8e0b1b.svg";